/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NdvrSecurity
 */
export interface NdvrSecurity {
    /**
     * 
     * @type {string}
     * @memberof NdvrSecurity
     */
    sId: string;
    /**
     * 
     * @type {string}
     * @memberof NdvrSecurity
     */
    symbol: string;
    /**
     * 
     * @type {string}
     * @memberof NdvrSecurity
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof NdvrSecurity
     */
    primaryExchange?: string;
    /**
     * 
     * @type {string}
     * @memberof NdvrSecurity
     */
    assetType: string;
    /**
     * 
     * @type {string}
     * @memberof NdvrSecurity
     */
    assetClass: string;
    /**
     * 
     * @type {string}
     * @memberof NdvrSecurity
     */
    cusip?: string;
    /**
     * 
     * @type {number}
     * @memberof NdvrSecurity
     */
    contractMultiplier?: number;
    /**
     * 
     * @type {number}
     * @memberof NdvrSecurity
     */
    priceMultiplier?: number;
    /**
     * 
     * @type {string}
     * @memberof NdvrSecurity
     */
    expirationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof NdvrSecurity
     */
    ndvrChainId?: string;
    /**
     * 
     * @type {string}
     * @memberof NdvrSecurity
     */
    isin?: string;
    /**
     * 
     * @type {string}
     * @memberof NdvrSecurity
     */
    shareClassId?: string;
    /**
     * 
     * @type {string}
     * @memberof NdvrSecurity
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof NdvrSecurity
     */
    maturityDate?: string;
    /**
     * 
     * @type {string}
     * @memberof NdvrSecurity
     */
    issuer?: string;
    /**
     * 
     * @type {number}
     * @memberof NdvrSecurity
     */
    coupon?: number;
}

/**
 * Check if a given object implements the NdvrSecurity interface.
 */
export function instanceOfNdvrSecurity(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sId" in value;
    isInstance = isInstance && "symbol" in value;
    isInstance = isInstance && "assetType" in value;
    isInstance = isInstance && "assetClass" in value;

    return isInstance;
}

export function NdvrSecurityFromJSON(json: any): NdvrSecurity {
    return NdvrSecurityFromJSONTyped(json, false);
}

export function NdvrSecurityFromJSONTyped(json: any, ignoreDiscriminator: boolean): NdvrSecurity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sId': json['s_id'],
        'symbol': json['symbol'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'primaryExchange': !exists(json, 'primary_exchange') ? undefined : json['primary_exchange'],
        'assetType': json['asset_type'],
        'assetClass': json['asset_class'],
        'cusip': !exists(json, 'cusip') ? undefined : json['cusip'],
        'contractMultiplier': !exists(json, 'contract_multiplier') ? undefined : json['contract_multiplier'],
        'priceMultiplier': !exists(json, 'price_multiplier') ? undefined : json['price_multiplier'],
        'expirationDate': !exists(json, 'expiration_date') ? undefined : json['expiration_date'],
        'ndvrChainId': !exists(json, 'ndvr_chain_id') ? undefined : json['ndvr_chain_id'],
        'isin': !exists(json, 'isin') ? undefined : json['isin'],
        'shareClassId': !exists(json, 'share_class_id') ? undefined : json['share_class_id'],
        'companyId': !exists(json, 'company_id') ? undefined : json['company_id'],
        'maturityDate': !exists(json, 'maturity_date') ? undefined : json['maturity_date'],
        'issuer': !exists(json, 'issuer') ? undefined : json['issuer'],
        'coupon': !exists(json, 'coupon') ? undefined : json['coupon'],
    };
}

export function NdvrSecurityToJSON(value?: NdvrSecurity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        's_id': value.sId,
        'symbol': value.symbol,
        'description': value.description,
        'primary_exchange': value.primaryExchange,
        'asset_type': value.assetType,
        'asset_class': value.assetClass,
        'cusip': value.cusip,
        'contract_multiplier': value.contractMultiplier,
        'price_multiplier': value.priceMultiplier,
        'expiration_date': value.expirationDate,
        'ndvr_chain_id': value.ndvrChainId,
        'isin': value.isin,
        'share_class_id': value.shareClassId,
        'company_id': value.companyId,
        'maturity_date': value.maturityDate,
        'issuer': value.issuer,
        'coupon': value.coupon,
    };
}

